/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Category } from '../models/category';
import { DataPageOfImage } from '../models/data-page-of-image';
import { imageBuildImageInputFile } from '../fn/image/image-build-image-input-file';
import { ImageBuildImageInputFile$Params } from '../fn/image/image-build-image-input-file';
import { imageDetail } from '../fn/image/image-detail';
import { ImageDetail$Params } from '../fn/image/image-detail';
import { imageGetAllImageList } from '../fn/image/image-get-all-image-list';
import { ImageGetAllImageList$Params } from '../fn/image/image-get-all-image-list';
import { imageGetcategorylistbypatient } from '../fn/image/image-getcategorylistbypatient';
import { ImageGetcategorylistbypatient$Params } from '../fn/image/image-getcategorylistbypatient';
import { imageList } from '../fn/image/image-list';
import { ImageList$Params } from '../fn/image/image-list';
import { ImageModels } from '../models/image-models';

@Injectable({ providedIn: 'root' })
export class ImageService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `imageGetcategorylistbypatient()` */
  static readonly ImageGetcategorylistbypatientPath = '/image/getcategorylistbypatient';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `imageGetcategorylistbypatient()` instead.
   *
   * This method doesn't expect any request body.
   */
  imageGetcategorylistbypatient$Response(params?: ImageGetcategorylistbypatient$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Category>>> {
    return imageGetcategorylistbypatient(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `imageGetcategorylistbypatient$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  imageGetcategorylistbypatient(params?: ImageGetcategorylistbypatient$Params, context?: HttpContext): Observable<Array<Category>> {
    return this.imageGetcategorylistbypatient$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Category>>): Array<Category> => r.body)
    );
  }

  /** Path part for operation `imageList()` */
  static readonly ImageListPath = '/image/getimagelist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `imageList()` instead.
   *
   * This method doesn't expect any request body.
   */
  imageList$Response(params?: ImageList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfImage>> {
    return imageList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `imageList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  imageList(params?: ImageList$Params, context?: HttpContext): Observable<DataPageOfImage> {
    return this.imageList$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfImage>): DataPageOfImage => r.body)
    );
  }

  /** Path part for operation `imageGetAllImageList()` */
  static readonly ImageGetAllImageListPath = '/image/getAllimagelist';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `imageGetAllImageList()` instead.
   *
   * This method doesn't expect any request body.
   */
  imageGetAllImageList$Response(params?: ImageGetAllImageList$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfImage>> {
    return imageGetAllImageList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `imageGetAllImageList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  imageGetAllImageList(params?: ImageGetAllImageList$Params, context?: HttpContext): Observable<DataPageOfImage> {
    return this.imageGetAllImageList$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfImage>): DataPageOfImage => r.body)
    );
  }

  /** Path part for operation `imageDetail()` */
  static readonly ImageDetailPath = '/image/getdetails/{patientId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `imageDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  imageDetail$Response(params: ImageDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<ImageModels>> {
    return imageDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `imageDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  imageDetail(params: ImageDetail$Params, context?: HttpContext): Observable<ImageModels> {
    return this.imageDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<ImageModels>): ImageModels => r.body)
    );
  }

  /** Path part for operation `imageBuildImageInputFile()` */
  static readonly ImageBuildImageInputFilePath = '/api/Image';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `imageBuildImageInputFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  imageBuildImageInputFile$Response(params?: ImageBuildImageInputFile$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return imageBuildImageInputFile(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `imageBuildImageInputFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  imageBuildImageInputFile(params?: ImageBuildImageInputFile$Params, context?: HttpContext): Observable<string> {
    return this.imageBuildImageInputFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
